/**
 * 登录与账号接口 —— docs/04 §7。
 *
 * 会话令牌与 API Key 走同一个 `Authorization: Bearer`，凭证的读写统一在
 * client.ts（见 `setAuthToken`）。这里只管接口形状，不碰存储。
 */

import type {
  AuthStatus,
  LoginRequest,
  LoginResponse,
  UserCreateRequest,
  UserInfo,
  UserUpdateRequest,
} from '@/types/api';
import { http } from './client';

/**
 * 未登录也能调。前端启动时用它回答两个问题：
 * 这个部署要不要登录（auth_required）、是不是还没有任何账号（needs_bootstrap）。
 */
export function getAuthStatus(signal?: AbortSignal) {
  return http.get<AuthStatus>('/auth/status', undefined, signal);
}

export function login(body: LoginRequest) {
  return http.post<LoginResponse>('/auth/login', body);
}

export function logout() {
  return http.post<void>('/auth/logout');
}

export function getMe(signal?: AbortSignal) {
  return http.get<UserInfo>('/auth/me', undefined, signal);
}

/** 改自己的口令。成功后除当前会话外的其它设备全部下线。 */
export function changePassword(oldPassword: string, newPassword: string) {
  return http.post<void>('/auth/password', {
    old_password: oldPassword,
    new_password: newPassword,
  });
}

/** 创建第一个管理员。库里已有账号时返回 409。 */
export function bootstrapAdmin(body: UserCreateRequest) {
  return http.post<UserInfo>('/auth/bootstrap', body);
}

export function listUsers(signal?: AbortSignal) {
  return http.get<{ items: UserInfo[] }>('/auth/users', undefined, signal);
}

export function createUser(body: UserCreateRequest) {
  return http.post<UserInfo>('/auth/users', body);
}

export function updateUser(userId: string, body: UserUpdateRequest) {
  return http.patch<UserInfo>(`/auth/users/${userId}`, body);
}

export function deleteUser(userId: string) {
  return http.del<void>(`/auth/users/${userId}`);
}
